import { createPortal } from 'react-dom';

type GenerationMode = 'sequential_context' | 'parallel';

type CarouselGenerationModeModalProps = {
  defaultMode: GenerationMode;
  onClose: () => void;
  onConfirm: (_mode: GenerationMode) => void;
};

export function CarouselGenerationModeModal({
  defaultMode,
  onClose,
  onConfirm,
}: CarouselGenerationModeModalProps) {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <div className="modal-header">
          <h2>Choose Carousel Mode</h2>
          <button className="modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className="modal-body" style={{ display: 'grid', gap: 10 }}>
          <p style={{ margin: 0, color: 'var(--text-secondary)' }}>
            How should AI generate your carousel images?
          </p>

          <button
            className="btn btn-secondary"
            onClick={() => onConfirm('sequential_context')}
            style={{ textAlign: 'left' }}
            autoFocus={defaultMode === 'sequential_context'}
          >
            <div style={{ fontWeight: 700 }}>Sequential</div>
            <div>
              <strong>Style Consistency:</strong> keeps a coherent look across slides.
            </div>
          </button>

          <button
            className="btn btn-secondary"
            onClick={() => onConfirm('parallel')}
            style={{ textAlign: 'left' }}
            autoFocus={defaultMode === 'parallel'}
          >
            <div style={{ fontWeight: 700 }}>Parallel (Faster)</div>
            <div>
              <strong>Speed First:</strong> generates all slides at once.
            </div>
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
